import loggerService from './loggerService';

const getInjector = async () => {
  try {
    await window.APP_EXTENSION_SDK_ANGULAR_JS_LOADED;
  } catch (error) {
    loggerService.error(error);

    return undefined;
  }

  return window.angular.element(document.body)?.injector();
};

export default getInjector;
